import React from 'react';
import { ArrowLeft, BookOpen, CheckCircle2 } from 'lucide-react';

export default function ReadingView({ setView, unit }) {
  return (
    <div className="p-6 pb-24 animate-in slide-in-from-right duration-500 space-y-6">
      
      {/* HEADER */}
      <button 
        onClick={() => setView('sets')}
        className="flex items-center gap-2 text-slate-400 font-bold hover:text-indigo-600 transition-colors"
      >
        <ArrowLeft size={18}/> Volver a Lecciones
      </button>

      <div className="bg-blue-50 p-6 rounded-[2rem] border-2 border-blue-100">
         <div className="flex items-center gap-4 mb-4">
            <div className="bg-blue-500 text-white p-3 rounded-xl shadow-lg shadow-blue-200">
                <BookOpen size={24} />
            </div>
            <div>
                <h1 className="text-2xl font-black text-blue-900">Reading Time</h1>
                <p className="text-blue-400 font-bold text-sm">Práctica de Lectura</p>
            </div>
         </div>
         
         <div className="prose prose-slate prose-lg bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
            <p className="mb-4">
                Here is a short story related to <strong>{unit.title}</strong> to practice your reading skills.
            </p>
            <p>
                "Once upon a time, in a busy airport, a traveler lost his passport..."
                <br/>
                <span className="text-slate-400 text-sm italic">(Aquí iría el contenido real de tu JSON de lecturas)</span>
            </p>
         </div>
      </div>

      <button 
        onClick={() => setView('sets')}
        className="w-full bg-indigo-600 text-white py-4 rounded-2xl font-black text-lg shadow-xl shadow-indigo-200 hover:scale-105 transition-transform flex items-center justify-center gap-2"
      >
        <CheckCircle2 /> TERMINAR LECTURA
      </button>
    </div>
  );
}